import { render, staticRenderFns } from "./newFormPage.vue?vue&type=template&id=1625474c&scoped=true&"
import script from "./newFormPage.vue?vue&type=script&lang=js&"
export * from "./newFormPage.vue?vue&type=script&lang=js&"
import style0 from "./newFormPage.vue?vue&type=style&index=0&id=1625474c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1625474c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
